<script setup lang="ts">
import { usePage } from "@inertiajs/vue3"
import { computed } from "vue"
import NotificationBell from "./NotificationBell.vue"
import UserMenuDropdown from "./UserMenuDropdown.vue"

type PageProps = {
  auth?: {
    current_company?: {
      name?: string
      logo_url?: string | null
    } | null
  }
}

const page = usePage<PageProps>()
const companyName = computed(() => page.props.auth?.current_company?.name || "Fabrik")
const logoUrl = computed(() => page.props.auth?.current_company?.logo_url || "")
</script>

<template>
  <header class="flex h-16 items-center justify-between border-b border-slate-200 bg-white px-6">
    <div class="flex items-center gap-3 text-lg font-semibold text-slate-900">
      <img v-if="logoUrl" :src="logoUrl" :alt="`Logo ${companyName}`" class="h-8 w-8 rounded object-contain" />
      <span>Fabrik</span>
    </div>

    <div class="flex items-center gap-3">
      <NotificationBell />
      <UserMenuDropdown />
    </div>
  </header>
</template>

